var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.022 17.057-5.866-6.235c-.164-.205-.287-.45-.287-.697 0-.205.123-.451.287-.656l5.866-6.235c.369-.41.984-.41 1.394-.04.41.369.41.984.041 1.394l-5.29 5.578 5.29 5.537c.37.41.37 1.026-.04 1.395-.411.369-1.026.369-1.395-.041"
  })));
};
export default SvgChevronLeft;